import {apiCall} from 'service/apiCall'
import {setLoading,modalToggle,setLoadingTable} from './general'
import Cookie from 'universal-cookie'
import {get} from 'lodash'
import * as actionTypes from 'redux/constants/client'
import * as proyekTypes from 'redux/constants/proyek'
const cookie=new Cookie
const token=cookie.get('login_cookie')
const profile=cookie.get('profile_cookie')
export const setFilterClient=(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_FILTER,
        payload:payload
    })
}
export const resetDetail=(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.RESET_DETAIL,
        payload:payload
    })
}
export const setDetailClient=(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_CLIENT_DETAIL,
        payload:payload
    })
}
export const getIndustry=()=>async dispatch=>{
    // dispatch(setLoading(true))
        let dataReq={
            url:'/sa/industry',
            method:'GET',
            data:{headers:{ 'Authorization': `Bearer ${token}`},}
        }
        let res=await dispatch(apiCall(dataReq))
        if(get(res,'status')===200){
            dispatch(setLoading(false))
            dispatch({
                type:actionTypes.GET_INDUSTRY,
                payload:res.data
            })
        }else{
            dispatch(setLoading(false))
        }
}
export const getClientList=(slug)=>async dispatch=>{
    dispatch(setLoadingTable(true))

    let datasent={
        url:`/client/list${slug}`,
        method:'GET',
        data:{headers:{ 'Authorization': `Bearer ${token}`},}
    }
    let res= await dispatch(apiCall(datasent))
    if(get(res,'status')===200){
        dispatch(setLoadingTable(false))

        dispatch({
            type:actionTypes.GET_CLIENT_LIST,
            payload:{
                client_list:res.data.items,
                client_pagination:res.data.info
            }
        })
        return res
        
    }else{
        dispatch(setLoadingTable(false))

    }
}
export const getClientListForDropDown=()=>async dispatch=>{
    dispatch(setLoading(true))

    let datasent={
        url:`/client/list`,
        method:'GET',
        data:{headers:{ 'Authorization': `Bearer ${token}`},}
    }
    let res= await dispatch(apiCall(datasent))
    if(get(res,'status')===200){
        dispatch(setLoading(false))

        dispatch({
            type:actionTypes.GET_CLIENT_LIST_FOR_DROPDOWN,
            payload:res.data
        })
        return res
        
    }else{
        dispatch(setLoading(false))

    }
}

export const deleteClient=(slug)=>async dispatch=>{
    dispatch(setLoading(true))
        let dataReq={
            url:`/client${slug}`,
            method:'DELETE',
            data:{headers:{ 'Authorization': `Bearer ${token}`},}
        }
        let res=await dispatch(apiCall(dataReq))
        if(get(res,'status')===204){
            dispatch(setLoading(false))
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Client berhasil dihapus",
                modal_component: "client",
                modal_size:400,
                modal_type:'alert',
                modal_data:{
                    msg:`<p></p> `,
                    ...res.data
                },
                modal_action:'success',
            }))
            return res
        }else{
            dispatch(setLoading(false))
        }
}

export const postClient=(data)=>async dispatch=>{
    dispatch(setLoading(true))
        let dataReq={
            url:`/client`,
            method:'POST',
            data:{data:data,headers:{ 'Authorization': `Bearer ${token}`},}
        }
        let res=await dispatch(apiCall(dataReq))
        if(get(res,'status')===200){
            dispatch(setLoading(false))
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Client berhasil disimpan",
                modal_component: "client",
                modal_size:400,
                modal_type:'alert',
                modal_data:{
                    msg:`<p></p> `,
                    ...res.data
                },
                modal_action:'success',
            }))
            return res
        }else{
            dispatch(setLoading(false))
        }
}
export const putClient=(data)=>async dispatch=>{
    dispatch(setLoading(true))
        let dataReq={
            url:`/client`,
            method:'PUT',
            data:{data:data,headers:{ 'Authorization': `Bearer ${token}`},}
        }
        let res=await dispatch(apiCall(dataReq))
        if(get(res,'status')===200){
            dispatch(setLoading(false))
            dispatch(modalToggle({ 
                modal_open: true,
                modal_title: "Client berhasil diupdate",
                modal_component: "client",
                modal_size:400,
                modal_type:'alert',
                modal_data:{
                    msg:`<p></p> `,
                    ...res.data
                },
                modal_action:'success',
            }))
        }else{
            dispatch(setLoading(false))
        }
}

export const getProjectByClient=(slug)=>async dispatch=>{
    dispatch(setLoadingTable(true))

    let datasent={
        url:`/wla/list${slug}`,
        method:'GET',
        data:{headers:{ 'Authorization': `Bearer ${token}`},}
    }
    let res= await dispatch(apiCall(datasent))
    if(get(res,'status')===200){
        dispatch(setLoadingTable(false))
        dispatch({
            type:proyekTypes.GET_PROYEK,
            payload:{
                proyek_list:res.data.items,
                proyek_pagination:res.data.info
            }
        })
        
        return res
        
    }else{
        dispatch(setLoadingTable(false))

    }
}